"use strict";

var _classCallCheck = require("/vercel/path0/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/vercel/path0/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/vercel/path0/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/vercel/path0/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/path0/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _WebGLTextureLoader = _interopRequireDefault(require("./WebGLTextureLoader"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var neverEnding = new Promise(function () {});
/**
 * A cache implementation of WebGLTextureLoader with a input hash function
 */

var WebGLTextureLoaderAsyncHashCache = /*#__PURE__*/function (_WebGLTextureLoader$d) {
  _inherits(WebGLTextureLoaderAsyncHashCache, _WebGLTextureLoader$d);

  var _super = _createSuper(WebGLTextureLoaderAsyncHashCache);

  function WebGLTextureLoaderAsyncHashCache() {
    var _this;

    _classCallCheck(this, WebGLTextureLoaderAsyncHashCache);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "disposes", new Map());

    _defineProperty(_assertThisInitialized(_this), "inputs", new Map());

    _defineProperty(_assertThisInitialized(_this), "promises", new Map());

    _defineProperty(_assertThisInitialized(_this), "results", new Map());

    _defineProperty(_assertThisInitialized(_this), "_disposed", false);

    return _this;
  }

  _createClass(WebGLTextureLoaderAsyncHashCache, [{
    key: "inputHash",
    value: function inputHash(input) {
      return "";
    } // An async load function that does not cache (WebGLTextureLoaderAsyncHashCache do the caching with inputHash). it also should return a dispose function to cancel a pending load

  }, {
    key: "loadNoCache",
    value: function loadNoCache(input) {
      return {
        promise: Promise.reject(new Error("loadNoCache is not implemented")),
        dispose: function dispose() {}
      };
    }
  }, {
    key: "dispose",
    value: function dispose() {
      var _this2 = this;

      var gl = this.gl,
          promises = this.promises,
          results = this.results,
          inputs = this.inputs,
          disposes = this.disposes;
      disposes.forEach(function (d) {
        return d();
      });
      results.forEach(function (result) {
        _this2.disposeTexture(result.texture);
      });
      promises.clear();
      results.clear();
      inputs.clear();
      disposes.clear();
      this._disposed = true;
    }
  }, {
    key: "disposeTexture",
    value: function disposeTexture(texture) {
      this.gl.deleteTexture(texture);
    }
  }, {
    key: "load",
    value: function load(input) {
      var _this3 = this;

      var hash = this.inputHash(input);
      var maybePromise = this.promises.get(hash);
      if (maybePromise) return maybePromise;
      var d = this.loadNoCache(input);
      this.disposes.set(hash, d.dispose);
      var promise = d.promise.then(function (result) {
        if (!_this3.promises.has(hash)) {
          return neverEnding;
        }

        _this3.disposes.delete(hash);

        _this3.results.set(hash, result);

        return result;
      });
      this.promises.set(hash, promise);
      return promise;
    }
  }, {
    key: "get",
    value: function get(input) {
      return this.results.get(this.inputHash(input));
    }
  }, {
    key: "cancelLoad",
    value: function cancelLoad(input) {
      var hash = this.inputHash(input);
      this.promises.delete(hash);
      var dispose = this.disposes.get(hash);

      if (dispose) {
        dispose();
        this.disposes.delete(hash);
      }
    }
  }]);

  return WebGLTextureLoaderAsyncHashCache;
}(_WebGLTextureLoader.default);

var _default = WebGLTextureLoaderAsyncHashCache;
exports.default = _default;